module.exports = __webpack_public_path__ + "img/IMG-20200919-WA0078.90b26fa9.jpg";